import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { allIndustriesData } from '../../data/allIndustriesData';
import { CompleteIndustryData } from '../../data/industryData';
// import IndustryBottlenecks from './IndustryBottlenecks';
import TechStackSection from './TechStackSection';
import WhyChooseReventLabs from './WhyChooseReventLabs';
import '../../styles/IndustryDetailPage.css';

// Additional components for various industry-specific sections
import MLOutcomes from './MLOutcomes';
import CaseStudies from './CaseStudies';
import SupportStages from './SupportStages';
import InfraFeatures from './InfraFeatures';
import ScrollTechStack from './ScrollIndustryTechStack';
import ScrollPinSection from '../ScrollPinSection';
import ServiceHeader from '../ServiceSections/ServiceHeader';

const IndustryDetailPage: React.FC = () => {
  const { industryId } = useParams<{ industryId: string }>();
  const industry = allIndustriesData[industryId as keyof typeof allIndustriesData] as CompleteIndustryData;

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!industry) {
    return (
      <div className="industry-not-found">
        <h1>Industry Not Found</h1>
        <p>Sorry, we couldn't find the industry you're looking for.</p>
        <Link to="/industries">View All Industries</Link>
      </div>
    );
  }

  const renderIndustrySection = () =>  {
    const Data = [];
    Data.push(
      <ServiceHeader
          key="hero"
          icon={industry.hero.icon}
          heading={industry.hero.title}
          subheading={industry.hero.subtitle}
          description={industry.hero.description}
          category={industry.hero.category}
          leftImage={industry.hero.leftImage}
          rightImage={industry.hero.rightImage}
          features={industry.hero.highlights}
        />
    );
    if(industry.components?.bottleneckSections){
      industry.components.bottleneckSections.forEach((section, index) => {
        switch (section.type) {
          case 'info-cards-1':
            Data.push(
                <ScrollPinSection
                  key={`${section.type}-${index}`}
                  sectionHeading={section.title}
                  cardData={section.items || []}
                />
            );
            break;

            case 'info-cards-2':
              Data.push(
                  <ScrollPinSection
                    key={`${section.type}-${index}`}
                    sectionHeading={section.title}
                    cardData={section.items || []}
                  />
              );
              break;

              case 'info-cards-3':
                Data.push(
                    <ScrollPinSection
                      key={`${section.type}-${index}`}
                      sectionHeading={section.title}
                      cardData={section.items || []}
                    />
                );
                break;
        }

      })
    }

    
    /* Why Choose Betaque Section */
    Data.push(
      <WhyChooseReventLabs 
      industryName={industry.hero.title}
      description={industry.hero.description}
      benefits={industry.benefits}
    />
    )

    /* Tech Stack Section - if available */

    if(industry.components.techStackItems){
      Data.push(
        <TechStackSection 
          title={`Our ${industry.hero.title} Engineering Stack`} 
          description={`ReventLabs ensures your ${industry.hero.title} infrastructure isn't just ready but optimized for performance, scale, and innovation.`}
          items={industry.components.techStackItems} 
        />
      );
    }
    
    if(industry.components.techStackItems){
      Data.push(
        <ScrollTechStack
          items={industry.components.techStackItems} 
        />
      );
    }

  /* Render ML Outcomes if available */
    if(industry.components.mlOutcomes){
      Data.push(
      <MLOutcomes outcomes={industry.components.mlOutcomes} />
      );
    }
      
    // {/* Render Case Studies if available */}
    if(industry.components.caseStudies){
      Data.push(
       <CaseStudies caseStudies={industry.components.caseStudies} />
      );
    }
          
    if(industry.components.supportStages){
      Data.push(
        <SupportStages stages={industry.components.supportStages} />      
      );
    }

    //  Render Infra Features if available 
    if(industry.components.infraFeatures){
      Data.push(
        <InfraFeatures features={industry.components.infraFeatures} />
      );
    }

    return Data;
  }

  return (
    <div className="ind-industry-detail-page">
      {/* Enhanced Breadcrumb */}
      {/* <div className="reventlabs-service-breadcrumb">
        <Link to="/">Home</Link> / <Link to="/industries">Industries</Link> / {industry.hero.title}
      </div> */}

      {/* Modern Hero Section */}
      {/* <div className="reventlabs-service-hero">
        <div className="reventlabs-service-hero-content">
          <div className="reventlabs-service-hero-left">
            <div className="reventlabs-service-meta">
              <span className="reventlabs-service-icon-large">{industry.hero.icon}</span>
              <span className="reventlabs-service-category-large">Industry</span>
            </div>
            
            <h1 className="reventlabs-service-title">{industry.hero.title}</h1>
            <h2 className="reventlabs-service-subtitle">{industry.hero.subtitle}</h2>
            <p className="reventlabs-service-description">{industry.hero.description}</p>
            
            {industry.hero.highlights && (
              <div className="reventlabs-service-highlights">
                {industry.hero.highlights.map((highlight, index) => (
                  <div key={index} className="reventlabs-highlight-item">
                    <span className="reventlabs-highlight-icon">✓</span>
                    <span>{highlight}</span>
                  </div>
                ))}
              </div>
            )}

            <div className="reventlabs-service-cta-buttons">
              <Link to="/contact" className="reventlabs-primary-cta-btn">
                Get Started Today
              </Link>
              <Link to="/contact" className="reventlabs-secondary-cta-btn">
                Schedule Consultation
              </Link>
            </div>
          </div>
        </div>
      </div> */}
      {renderIndustrySection()}     
    </div>
  );
};

export default IndustryDetailPage; 